import * as React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
import { AirportFragment } from '@websky/graphql';

interface Props {
	className?: string;
	time: string;
	airport?: AirportFragment;
	arrival?: boolean;
	thin?: boolean;
	date?: string;
}

const Point: React.FC<Props> = ({ className, time, airport, arrival, thin, date }) => {
	const theme = useTheme('DesktopFlightRoute').PointStyles;

	return (
		<div
			className={cn(
				theme.point,
				{
					[theme.point_arrival]: arrival,
					[theme.point_thin]: thin
				},
				className
			)}
		>
			<div className={theme.date__container}>
				{date && <div className={theme.date}>{date}</div>}

				<div className={theme.time}>{time}</div>

				{airport && (
					<div className={theme.airport}>
						{airport.city.name ?? airport.name} ({airport.iata})
					</div>
				)}
			</div>
		</div>
	);
};

export default Point;
